import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiShield, FiX } from "react-icons/fi";
import { TbPigMoney } from "react-icons/tb";
import { ModalOverlay, ModalContainer, ModalHeader, ModalTitle, ModalCloseButton, ModalBody, ModalStaffBadge, ModalStaffBadgeText } from "./Styles";
import { useBusiness } from "../../Common/Hooks/useBusiness";
import { SubscriptionContent } from "../../Pages/Pricing/Components/SubscriptionContent";

interface SubscriptionModalProps {
  onClose: () => void;
}

export const SubscriptionModal = ({ onClose }: SubscriptionModalProps) => {
  const { t } = useTranslation();
  const { business } = useBusiness();
  const [isCreditHistoryOpen, setIsCreditHistoryOpen] = useState(false);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEscape);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [onClose]);

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flex: 1 }}>
            <div style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "#dbeafe",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <TbPigMoney size={20} color="#3b82f6" />
            </div>
            <div>
              {isCreditHistoryOpen ? (
                <ModalTitle>{t("common.sidebar.subscriptionModal.creditHistoryTitle")}</ModalTitle>
              ) : (
                <>
                  <ModalTitle style={{ marginBottom: "0.25rem" }}>{t("common.sidebar.subscriptionModal.title")}</ModalTitle>
                  <p style={{ fontSize: "0.875rem", color: "#6b7280", margin: 0 }}>
                    {t("common.sidebar.subscriptionModal.subtitle")}
                  </p>
                </>
              )}
            </div>
          </div>
          {business?.isStaffOwned && (
            <ModalStaffBadge>
              <FiShield size={12} color="#001d30" />
              <ModalStaffBadgeText>{t("common.sidebar.subscriptionModal.staffBadge")}</ModalStaffBadgeText>
            </ModalStaffBadge>
          )}
          <ModalCloseButton onClick={onClose}>
            <FiX size={20} />
          </ModalCloseButton>
        </ModalHeader>
        <ModalBody>
          <SubscriptionContent
            onClose={onClose}
            isCreditHistoryOpen={isCreditHistoryOpen}
            onCreditHistoryOpenChange={setIsCreditHistoryOpen}
          />
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
};
